import './Problema.css'
import { useState } from 'react';
import { useEffect } from 'react';
import Highlight from 'react-highlight'

function Problema(props) {


    useEffect(() => {
        if (localStorage.getItem(props.codigo) !== null ) { //localStorage.getItem(props.descripcion).length > 0
            let c1 = localStorage.getItem(props.codigo)
            setSolucion(c1)
            let c2 = props.solucion
            compararObjetos(c1, c2)            
        }    
      },[props.codigo]);


    const [solucion, setSolucion] = useState('');

    const [inputresultado, setInputresultado] = useState('');


    function cambioSolucion(e) {
        setSolucion((valores) => (e.target.value))
    }

    function cambioColor() {
        setInputresultado('')
    }

    function deepEqual(x, y) {   
        if (x === null || x === undefined || y === null || y === undefined) { return x === y; }
        // after this just checking type of one would be enough
        if (x.constructor !== y.constructor) { return false; }
        // if they are functions, they should exactly refer to same one (because of closures)
        if (x instanceof Function) { return x === y; }
        // if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)
        if (x instanceof RegExp) { return x === y; }
        if (x === y || x.valueOf() === y.valueOf()) { return true; }
        if (Array.isArray(x) && x.length !== y.length) { return false; }
    
        // if they are dates, they must had equal valueOf
        if (x instanceof Date) { return false; }
    
        // if they are strictly equal, they both need to be object at least
        if (!(x instanceof Object)) { return false; }
        if (!(y instanceof Object)) { return false; }
    
        // recursive object equality check
        var p = Object.keys(x);
        return Object.keys(y).every(function (i) { return p.indexOf(i) !== -1; }) &&
            p.every(function (i) { return deepEqual(x[i], y[i]); });
    }
    
    function compararObjetos(c1, c2) {
        if(c1==='error') {
            try {
                eval(props.programa)
            } catch(error) {
                setInputresultado('correcto - error: '+error)
                return
            }
        }
        try {
            if (c1.toString()==='NaN' && eval(c2).toString()==='NaN') {
                setInputresultado('correcto')
                return;
            }
            if (deepEqual(eval('('+c1+')'), eval('('+c2+')'))) {
                setInputresultado('correcto');
            }
            else {
                setInputresultado('incorrecto');
            }
        }
        catch (error) {
            setInputresultado('incorrecto');
        }

    }

    function verificarSolucion() {
        if(solucion.length===0) 
          return
        localStorage.setItem(props.codigo, solucion)
        let c1 = solucion
        let c2 = props.solucion
        compararObjetos(c1, c2)            
    }

    function presionTecla(e) {
        if (e.key === 'Enter') {
            verificarSolucion()
        }
    }

    return (<div className='problemacompleto'>
        <div className='descripcion' style={{ whiteSpace: "break-spaces"}} dangerouslySetInnerHTML={{__html: props.descripcion}}></div>
        <Highlight className='javascript programa'>{props.programa}</Highlight>
        <div>
            <input type="text" className={`inputsolucion ${inputresultado}`} value={solucion} onChange={cambioSolucion} onBlur={() => verificarSolucion()} onFocus={cambioColor} spellCheck="false" onKeyDown={presionTecla} />
            <button className="botonverificar" onClick={() => verificarSolucion()}>Verificar</button>
        </div>
        <div>
            <div className='descripcion-resultado'>Resultado:{inputresultado}</div>
        </div>
    </div>)
}

export default Problema;